<template>
  <el-dialog
    :visible.sync="caseModelAdialogVisible"
    :append-to-body="true"
    :close-on-click-modal="false"
    custom-class="container-dialog"
    :show-close="false"
    width="700px"
  >
    <div
      class="content"
      :class="$store.state.identity === 2 ? 'content-vip' : 'content-common'"
    >
      <Close :visible.sync="caseModelAdialogVisible" @onClose="onClose"></Close>
      <div class="box-video">
        <video
          class="video"
          ref="myVideo"
          :controls="controls"
          controlslist="nodownload"
        > 
          <source :src="activedCaseDetail.videoUrl" type="video/mp4" />
        </video> 
        <div class="play" v-if="!controls">
          <img
            @click="operateVideo" 
            src="../../assets/images/case/play.png" 
            width="40"
            height="40"
            alt=""
          />
        </div>
        <div class="box-innovate">
          <div class="innovate" v-if="activedCaseDetail.isinnovation === 1">
            创新模块
          </div>
        </div>
      </div>

      <div class="info">
        <div class="info-content">
          <div class="top">
            <p class="title">{{ activedCaseDetail.name }}</p>
            <div class="type">
              {{ activedCaseDetail.typeName }}
              <!-- <div class="innovate" v-if="activedCaseDetail.isinnovation===1">创新模块</div> -->
            </div>
          </div>
          <!-- <div class="item" v-if="activedCaseDetail.typeId === 2">
                        <div class="label">尺寸：</div>
                        <div class="text">{{ activedCaseDetail.measure }}</div>
                    </div> -->
          <div class="item">
            <div class="label">适用行业：</div>
            <div class="text">{{ activedCaseDetail.industry.join("、") }}</div>
          </div>
          <div class="item">
            <div class="label">使用场景：</div>
            <div class="text">{{ activedCaseDetail.scene.join("、") }}</div>
          </div>
          <div class="item" v-if="activedCaseDetail.pageArea && activedCaseDetail.pageArea.length">
            <div class="label">页面区域：</div>
            <div class="text">{{ activedCaseDetail.pageArea.join("、") }}</div>
          </div>
          <div class="item" v-if="activedCaseDetail.function && activedCaseDetail.function.length">
            <div class="label">功能：</div>
            <div class="text">{{ activedCaseDetail.function.join("、") }}</div>
          </div>
          <div class="item" v-if="activedCaseDetail.promotion && activedCaseDetail.promotion.length">
            <div class="label">促销节点：</div>
            <div class="text">{{ activedCaseDetail.promotion.join("、") }}</div>
          </div>
          <div class="item" v-if="activedCaseDetail.typeId !== 1">
            <div class="label">简介：</div>
            <div class="text">{{ activedCaseDetail.caseDesc }}</div>
          </div>
        </div>
        <div class="bottom" v-if="$store.state.identity !== 2">
          <div class="button">
            <button class="button-consult" @click="onConsult(26)">
              咨询客服
            </button>
            <!-- <CustomerService>
                            <button class="button-consult" @click="onConsult(26)">
                                咨询客服</button>
                        </CustomerService> -->

            <div class="collection" @click="onCollection">
              <svg
                t="1663236173727"
                v-if="!activedCaseDetail.collectionId"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2358"
                width="22"
                height="22"
              >
                <path
                  d="M335.008 916.629333c-35.914667 22.314667-82.88 10.773333-104.693333-25.557333a77.333333 77.333333 0 0 1-8.96-57.429333l46.485333-198.24a13.141333 13.141333 0 0 0-4.021333-12.864l-152.16-132.586667c-31.605333-27.52-35.253333-75.648-8.234667-107.733333a75.68 75.68 0 0 1 51.733333-26.752L354.848 339.2c4.352-0.362667 8.245333-3.232 10.026667-7.594667l76.938666-188.170666c16.032-39.2 60.618667-57.92 99.52-41.461334a76.309333 76.309333 0 0 1 40.832 41.461334l76.938667 188.16c1.781333 4.373333 5.674667 7.253333 10.026667 7.605333l199.712 16.277333c41.877333 3.413333 72.885333 40.458667 69.568 82.517334a76.938667 76.938667 0 0 1-26.08 51.978666l-152.16 132.586667c-3.541333 3.082667-5.141333 8.074667-4.021334 12.853333l46.485334 198.24c9.621333 41.013333-15.36 82.336-56.138667 92.224a75.285333 75.285333 0 0 1-57.525333-9.237333l-170.976-106.24a11.296 11.296 0 0 0-12.010667 0l-170.986667 106.24zM551.786667 756.032l170.976 106.24c2.624 1.621333 5.717333 2.122667 8.650666 1.408 6.410667-1.557333 10.56-8.426667 8.928-15.424l-46.485333-198.24a77.141333 77.141333 0 0 1 24.277333-75.733333L870.293333 441.706667c2.485333-2.165333 4.053333-5.312 4.330667-8.746667 0.565333-7.136-4.490667-13.173333-10.976-13.696l-199.712-16.288a75.989333 75.989333 0 0 1-64.064-47.168l-76.938667-188.16a12.309333 12.309333 0 0 0-6.538666-6.741333c-5.898667-2.496-12.725333 0.373333-15.328 6.741333l-76.949334 188.16a75.989333 75.989333 0 0 1-64.064 47.168l-199.701333 16.288a11.68 11.68 0 0 0-7.978667 4.181333 13.226667 13.226667 0 0 0 1.333334 18.261334l152.16 132.586666a77.141333 77.141333 0 0 1 24.277333 75.733334l-46.485333 198.229333a13.333333 13.333333 0 0 0 1.514666 9.877333c3.488 5.792 10.581333 7.530667 16.064 4.128l170.986667-106.229333a75.296 75.296 0 0 1 79.562667 0z"
                  p-id="2359"
                  fill="#cdcdcd"
                ></path>
              </svg>
              <svg
                t="1663236275088"
                v-else
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2532"
                width="22"
                height="22"
              >
                <path
                  d="M509.606998 104.904235c-24.043602 0-45.922912 13.226233-56.177464 33.95637L356.189863 336.302419l-223.674269 32.54216c-22.983457 3.304256-42.100864 18.718317-49.481971 39.659255-7.381108 21.048385-1.812275 44.23241 14.431687 60.033281l163.916257 160.125931-38.011732 222.016513c-3.868097 22.408359 6.03239 44.819788 25.458835 57.94676 10.69662 7.116071 23.204491 10.784624 35.757388 10.784624 10.298554 0 20.663622-2.475378 30.055526-7.337105l194.987926-102.7205L704.662463 912.072815c9.369392 4.861728 19.712971 7.337105 29.990035 7.337105 12.57541 0 25.082258-3.668553 35.778878-10.784624 19.426445-13.126972 29.305443-35.538401 25.460882-57.94676l-38.012755-222.016513 163.937746-160.125931c16.22145-15.812127 21.810748-38.984896 14.408151-60.033281-7.402597-20.940938-26.51898-36.353976-49.503461-39.659255L663.04767 336.302419l-97.240695-197.441814C555.619962 118.131491 533.695626 104.904235 509.606998 104.904235L509.606998 104.904235z"
                  p-id="2533"
                  fill="#df583a"
                ></path>
              </svg>
            </div>
          </div>
          <div
            class="tip"
            v-if="
              (activedCaseDetail.isfree !== 0 &&
                activedCaseDetail.typeId === 1) ||
              activedCaseDetail.typeId === 2
            "
          >
            <p class="text">升级年框可享免费使用</p>
            <div class="more" @click="openCaseModelB">
              <p>了解更多</p>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
        <div class="bottom bottom-vip" v-else>
          <div class="button">
            <button class="button-consult" @click="onConsult(27)">
              咨询使用
            </button>
            <!-- <CustomerService>
                           
                        </CustomerService> -->
            <div class="collection" @click="onCollection">
              <svg
                t="1663236173727"
                v-if="!activedCaseDetail.collectionId"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2358"
                width="22"
                height="22"
              >
                <path
                  d="M335.008 916.629333c-35.914667 22.314667-82.88 10.773333-104.693333-25.557333a77.333333 77.333333 0 0 1-8.96-57.429333l46.485333-198.24a13.141333 13.141333 0 0 0-4.021333-12.864l-152.16-132.586667c-31.605333-27.52-35.253333-75.648-8.234667-107.733333a75.68 75.68 0 0 1 51.733333-26.752L354.848 339.2c4.352-0.362667 8.245333-3.232 10.026667-7.594667l76.938666-188.170666c16.032-39.2 60.618667-57.92 99.52-41.461334a76.309333 76.309333 0 0 1 40.832 41.461334l76.938667 188.16c1.781333 4.373333 5.674667 7.253333 10.026667 7.605333l199.712 16.277333c41.877333 3.413333 72.885333 40.458667 69.568 82.517334a76.938667 76.938667 0 0 1-26.08 51.978666l-152.16 132.586667c-3.541333 3.082667-5.141333 8.074667-4.021334 12.853333l46.485334 198.24c9.621333 41.013333-15.36 82.336-56.138667 92.224a75.285333 75.285333 0 0 1-57.525333-9.237333l-170.976-106.24a11.296 11.296 0 0 0-12.010667 0l-170.986667 106.24zM551.786667 756.032l170.976 106.24c2.624 1.621333 5.717333 2.122667 8.650666 1.408 6.410667-1.557333 10.56-8.426667 8.928-15.424l-46.485333-198.24a77.141333 77.141333 0 0 1 24.277333-75.733333L870.293333 441.706667c2.485333-2.165333 4.053333-5.312 4.330667-8.746667 0.565333-7.136-4.490667-13.173333-10.976-13.696l-199.712-16.288a75.989333 75.989333 0 0 1-64.064-47.168l-76.938667-188.16a12.309333 12.309333 0 0 0-6.538666-6.741333c-5.898667-2.496-12.725333 0.373333-15.328 6.741333l-76.949334 188.16a75.989333 75.989333 0 0 1-64.064 47.168l-199.701333 16.288a11.68 11.68 0 0 0-7.978667 4.181333 13.226667 13.226667 0 0 0 1.333334 18.261334l152.16 132.586666a77.141333 77.141333 0 0 1 24.277333 75.733334l-46.485333 198.229333a13.333333 13.333333 0 0 0 1.514666 9.877333c3.488 5.792 10.581333 7.530667 16.064 4.128l170.986667-106.229333a75.296 75.296 0 0 1 79.562667 0z"
                  p-id="2359"
                  fill="#cdcdcd"
                ></path>
              </svg>
              <svg
                t="1663236275088"
                v-else
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2532"
                width="22"
                height="22"
              >
                <path
                  d="M509.606998 104.904235c-24.043602 0-45.922912 13.226233-56.177464 33.95637L356.189863 336.302419l-223.674269 32.54216c-22.983457 3.304256-42.100864 18.718317-49.481971 39.659255-7.381108 21.048385-1.812275 44.23241 14.431687 60.033281l163.916257 160.125931-38.011732 222.016513c-3.868097 22.408359 6.03239 44.819788 25.458835 57.94676 10.69662 7.116071 23.204491 10.784624 35.757388 10.784624 10.298554 0 20.663622-2.475378 30.055526-7.337105l194.987926-102.7205L704.662463 912.072815c9.369392 4.861728 19.712971 7.337105 29.990035 7.337105 12.57541 0 25.082258-3.668553 35.778878-10.784624 19.426445-13.126972 29.305443-35.538401 25.460882-57.94676l-38.012755-222.016513 163.937746-160.125931c16.22145-15.812127 21.810748-38.984896 14.408151-60.033281-7.402597-20.940938-26.51898-36.353976-49.503461-39.659255L663.04767 336.302419l-97.240695-197.441814C555.619962 118.131491 533.695626 104.904235 509.606998 104.904235L509.606998 104.904235z"
                  p-id="2533"
                  fill="#df583a"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import CustomerService from "@/components/customerService";
import { copy } from "@/utils/clipboard";
import { saveBrowse, saveUserBrowseData } from "@/api/common";
import { collectionByType, removeCollection } from "@/api/case";
import Close from "@/components/close";
export default {
  components: {
    CustomerService,
    Close,
  },
  inject: {
    setChildrenRef: {
      // 注册子组件
      default: () => {},
    },
    getParentRef: {
      // 获取根组件实例
      from: "getRef",
      default: () => {},
    },
    getParentChildrenRef: {
      // 获取根组件链下任何注册的子组件
      from: "getChildrenRef",
      default: () => {},
    },
  },
  props: {
    caseModelAdialogVisible: {
      type: Boolean,
      default: true,
      required: true,
    },
    activedCaseDetail: {
      type: Object,
      default: () => {
        return {};
      },
      required: false,
    },
  },
  data() {
    return {
      controls: false,
    };
  },
  created() {
    console.log(this.activedCaseDetail, "activedCaseDetail");
  },
  methods: {
    //保存浏览记录
    async onSaveBrowse() {
      try {
        const params = {
          type: 0,
          id: this.detail.caseId,
        };
        const res = await saveBrowse(params);
        this.getParentRef().getList();
      } catch (e) {
        console.log(e);
      }
    },
    // 播放视频
    operateVideo() {
      this.controls = true;
      this.onSaveBrowse();
      this.$refs.myVideo.play();
    },
    onClose() {
      window.qimosdk.closeChatBox();
      this.$emit("update:caseModelAdialogVisible", false);
    },

    // 联系客服记录
    onConsult(type) {
      window.m7CardInfo = {
        left: {
          url:
            this.$store.state.identity === 2
              ? "data:image/png;base64,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"
              : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABYCAMAAABlEJHTAAAAD1BMVEVHcExETv9ETv9EUP9ETv/uW4AzAAAABHRSTlMAfr9A+H3QJwAAApVJREFUeAGtlYuyhCAMQ03L/3/zgqC8AhRW5t6ZFe0x6QOvw6Ui1xdL4fw6iRRoLSiATCig3XDSgxws8l2TBi0UIIGM/pzTwcYrqXtklJv2OUlusiSTvc6h58SNQpKVVOXmvvJ/ruBYUKrMobQcS84fZ5Id+q6+YwWQrM3Q6akwGh0oEsZfxgbfQIVSqe9tvFFB1JX92VFBTvh/MCF5PnF32otOsKCKzpFcg1iycAs7rR4fLucXqfYBee31umo5vngCww99s2ZDFYPyNHj8Ja9bW7Kushkk1dCX1eeuyqVZlo9ILamDM2YpC4+z1JDx3YUG2A+ZZ1A1g+55Js1icRaT9IDCBcrRNh8Oz8igKEEhoDwi1NSj5Wehev3eSfOeWtO52mquNcp8LLPVHqb6lah/LHaoY1k96UuUfEayHafdUkY6cygUha/sHaEGpAMUd3eA0iFpFzUyt42agabN0L5m4m3Vov4gz2exLDhzf3dPA2rALFNlIuRU6faoTZd4F6ZD17rwp8EZ6jsStvMkodqub7C9nIvoa+UfUVIU7U9RWoX9Iwp12HWOQjO3xu4UXyW/pJzKJsw6M+R+pQJEFFZeKImi6k6XPk6YvWuZdGgfJ1ZRqBsQfZxwUdOmwpsY9BloRblJpu6ZAFEgRJT2KDQlA1Eg/Vb/jcqkNKbxWkkLt5EKTnrnnZGU+BvkSfL3Qwgpvg8GUvnVCBsyeGxKQisBRNJjei6qM6NMU/pwL0U1GoShboNYieoKTI0I9z0/mdm0R/krf0yAHqCofx3kXRb+2LaIMRWVavom5Y21QPHbH6KYwwVKBq3C9hdtNaovq+Exyn2FYnGLXA3fREb6FIX+zmEzsDFZDI6PGd5AfWs1g1sLM9QP1TQe8NTQh6oAAAAASUVORK5CYII=", // 左侧图片地址，可不填
        },
        right1: {
          text: this.activedCaseDetail.name, // 首行文字内容，展示时超出两行隐藏，卡片上单行隐藏
          color: "#000", // 字体颜色，支持十六位 #ffffff 格式的颜色，不填或错误格式默认#595959
          fontSize: 14, // 字体大小， 默认12 ， 请传入number类型的数字
        },
        right2: {
          text: this.activedCaseDetail.typeName, // 第二行文字内容，展示时超出两行隐藏，卡片上单行隐藏
          color: "#666", // 字体颜色，支持十六位 #ffffff 格式的颜色，不填或错误格式默认#595959
          fontSize: 12, // 字体大小， 默认12 ， 请传入number类型的数字
        },
        right3: {
          text: "", // 第三行文字内容，展示时超出两行隐藏，卡片上单行隐藏
          color: "#ff6b6b", // 字体颜色，支持十六位 #ffffff 格式的颜色，不填或错误格式默认#ff6b6b
          fontSize: 14, // 字体大小， 默认14 ， 请传入number类型的数字
        },  
        extraInfos: [""], // 额外信息，访客不可见，座席点击卡片上的更多可见，可不填，字符串形式的文本数组
        url: this.activedCaseDetail.videoUrl, // 点击可跳转的链接
      };
      window.qimoChatClick();
      saveUserBrowseData({
        typeId: type,
        spmId: this.activedCaseDetail.caseId,
      });
    },
    // 收藏
    onCollection() {
      if (this.$store.state.identity === 0) {
        this.$store.commit("onShowLogindialog", true);
        return false;
      }
      if (this.activedCaseDetail.collectionId) {
        this.onCancelCollection();
      } else {
        this.onSaveCollection();
      }
    },
    // 收藏案例
    async onSaveCollection() {
      const data = {
        type: 0,
        id: this.activedCaseDetail.caseId,
      };
      try {
        const res = await collectionByType(data);
        this.activedCaseDetail.collectionId = 1;
        this.activedCaseDetail.collectionNum = this.activedCaseDetail.collectionNum + 1;

        // this.getParentRef().getList()
      } catch (e) {
        // this.$message.error(e.message)
      }
    },
    // 了解更多
    openCaseModelB() {
      this.$parent.caseModelBdialogVisible = true;
      saveUserBrowseData({
        typeId: 28,
        spmId: this.activedCaseDetail.caseId,
      });
    },
    // 取消收藏案例
    async onCancelCollection() {
      const data = {
        type: 0,
        id: this.activedCaseDetail.caseId,
      };
      try {
        const res = await removeCollection(data);
        this.activedCaseDetail.collectionId = null;
        this.activedCaseDetail.collectionNum = this.activedCaseDetail.collectionNum - 1;

        // this.getParentRef().getList()
      } catch (e) {
        // this.$message.error(e.message)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  width: 100%;
  height: 100%;

  .box-video {
    width: 258px;
    height: 550px;
    border: 1px solid rgb(244, 244, 244);
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    margin-right: 35px;

    .video {
      width: 100%;
      height: 100%;
    }

    .play {
      position: absolute;
      height: 100%;
      width: 100%;
      background: rgba(0, 0, 0, 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      left: 0;
      top: 0;
    }
  }

  .box-innovate {
    position: absolute;
    z-index: 99;
    top: 0px;
    width: 75px;
    height: 72px;
    overflow: hidden;
    left: 0px;

    .innovate {
      width: 92px;
      height: 24px;
      color: rgb(255, 255, 255);
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgb(255, 255, 255);
      background: linear-gradient(
        to left top,
        rgba(254, 220, 68, 1) 0%,
        rgba(250, 112, 154, 1) 100%
      );
      transform: rotate(-45deg) translateX(-24px) translateY(-6px);
    }
  }

  .info {
    flex: 1;
    height: 558px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .info-content {
      .top {
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
          color: rgb(0, 0, 0);
          font-size: 24px;
        }

        .type {
          margin-top: 10px;
          width: 90px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 20px;
          font-size: 14px;
          position: relative;

          .innovate {
            position: absolute;
            z-index: 99;
            position: absolute;
            width: 56px;
            height: 18px;
            top: -9px;
            right: -40px;
            color: rgb(255, 255, 255);
            font-size: 12px;
            text-align: center;
            line-height: 18px;
            color: rgb(255, 255, 255);
            background: linear-gradient(
              to left top,
              rgba(254, 220, 68, 1) 0%,
              rgba(250, 112, 154, 1) 100%
            );
            border-radius: 9px;
          }
        }
      }

      .price {
        margin: 18px 0;
        height: 80px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .tag {
          padding: 0px 5px;
          position: absolute;
          left: 0;
          top: 0;
          font-size: 12px;
          border-radius: 8px 0px 8px 0px;
        }

        .text {
          display: flex;
          align-items: flex-end;
          color: rgb(235, 28, 38);
          font-weight: bold;

          del {
            font-size: 18px;
            line-height: 22px;
          }

          p {
            font-size: 28px;
            line-height: 28px;
            margin: 0 5px;
          }

          .start {
            color: rgba(0, 0, 0, 0.5);
            font-size: 14px;
            font-weight: 400;

            text-align: center;
            text-decoration-line: underline;
          }
        }
      }

      .item {
        padding: 13px 0;

        .label {
          color: rgba(0, 0, 0, 0.5);
          font-size: 12px;
        }

        .text {
          margin-top: 10px;
          flex: 1;
          color: rgba(0, 0, 0, 1);
          line-height: 18px;
        }
      }
    }

    .bottom {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .button {
        display: flex;
        align-items: center;

        .button-consult {
          width: 262px;
          height: 40px;
          color: #fff;
          font-weight: bold;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          border: none;
          cursor: pointer;

          &:hover {
            opacity: 0.7;
          }
        }

        .collection {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          margin-left: 5px;

          &:hover {
            opacity: 0.7;
          }

          .icon {
            width: 25px;
          }
        }
      }

      .tip {
        color: rgb(185, 162, 125);
        font-size: 14px;
        margin-top: 8px;
        display: flex;
        align-items: center;

        .more {
          font-size: 12px;
          // width: 66px;
          padding: 0px 6px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000;
          background: linear-gradient(
            to right,
            rgba(243, 217, 172, 1) 11.647%,
            rgba(234, 189, 110, 1) 100%
          );
          border-radius: 10px;
          margin-left: 5px;

          cursor: pointer;

          &:hover {
            opacity: 0.7;
          }
        }

        .text-upgrade {
          cursor: pointer;

          &:hover {
            opacity: 0.7;
          }
        }
      }
    }
  }

  .close {
    position: absolute;
    top: 14px;
    right: 14px;
    cursor: pointer;
  }
}

.content-vip {
  .info-content {
    .price {
      background: rgb(252, 246, 231);
      /* 金色渐变2 */
      border: 1px solid rgba(234, 189, 110, 1);

      .tag {
        color: rgb(64, 34, 0);

        background: linear-gradient(
          to right,
          rgba(234, 188, 109, 1) 0%,
          rgba(244, 218, 175, 1) 100%
        );
      }
    }

    .type {
      background: rgb(252, 246, 231);
      color: rgb(64, 34, 0);
    }
  }

  .bottom {
    .button-consult {
      background: linear-gradient(
        to right,
        rgba(243, 217, 172, 1) 11.647%,
        rgba(234, 189, 110, 1) 100%
      );
    }

    .collection {
      border: 1px solid rgb(234, 221, 204);
      color: rgb(185, 162, 125);
    }
  }
}

.content-common {
  .info-content {
    .price {
      background: rgb(247, 247, 247);
      /* 金色渐变2 */
      border: 1px solid rgba(31, 209, 250, 1);

      .tag {
        color: #fff;
        background: linear-gradient(
          to right,
          rgba(69, 79, 255, 1) 0%,
          rgba(31, 209, 250, 1) 99.237%
        );
      }
    }

    .type {
      background: rgba(69, 79, 255, 0.1);
      color: rgb(69, 79, 255);
    }
  }

  .bottom {
    .button-consult {
      background: rgb(69, 79, 255);
    }

    .collection {
      border: 1px solid rgb(232, 232, 232);
      color: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>

<style lang="scss">
.container-dialog {
  border-radius: 20px !important;
  width: 709px;
  // height: 638px;
  position: relative;
  overflow: hidden;

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>